// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__vpmQY","title":"FrontImage_title__20y5E"};